import React, { useEffect, useRef, useState } from 'react';

const TrustpilotWidget = () => {
    const ref = useRef(null);
    const [scriptLoaded, setScriptLoaded] = useState(false);

    useEffect(() => {
        const script = document.querySelector(
            'script[src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]'
        );

        if (!script) {
            // Create and load the script if it doesn't already exist
            const newScript = document.createElement('script');
            newScript.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
            newScript.async = true;
            newScript.onload = () => {
                setScriptLoaded(true);
                // Call Trustpilot loadWidgets or appropriate method
                if (window.Trustpilot && typeof window.Trustpilot.loadWidgets === 'function') {
                    window.Trustpilot.loadWidgets();
                } else {
                    console.error('Trustpilot.loadWidgets is not available');
                }
            };
            newScript.onerror = () => {
                console.error('Failed to load the Trustpilot script');
            };
            document.head.appendChild(newScript);

            return () => {
                document.head.removeChild(newScript);
            };
        } else {
            setScriptLoaded(true);
        }
    }, []);

    useEffect(() => {
        if (scriptLoaded && window.Trustpilot && ref.current) {
            // Initialize the TrustBox widget
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, [scriptLoaded]);

    return (
        <div
            ref={ref} // Reference to the element where the TrustBox will be loaded
            className='trustpilot-widget'
            data-locale='en-US'
            data-template-id='56278e9abfbbba0bdcd568bc'
            data-businessunit-id='662bc063b865f2258ca5d1cc'
            data-style-height='52px'
            data-style-width='100%'
        >
            <a href='https://www.trustpilot.com/review/example.com' target='_blank' rel='noopener noreferrer'>
            </a>
        </div>
    );
};

export default TrustpilotWidget;
